<template>
    <tr v-pml-popover="{ content: reasons, html: true }">
        <td class="t_center">
            <span class="initial_name" v-pml-tooltip.top-right="findMember(item.member_id).full_name"> {{ findMember(item.member_id).name_initials }} </span>
        </td>
        <td>
            <p class="m-b-0">{{ item.title }}</p>
            <span class="label" :style="{ 'background-color': findAccessWay(item.access_way_id).color }">{{ item.access_way_id | pmlAccessWayById }}</span>
        </td>
        <td>
            <p class="m-b-0">{{ item.due_date_at | pmlDate('DD/MM/YYYY HH:mm') }}</p>
            <small><i class="fa fa-clock-o"></i> {{ item.remember_at | pmlDate('DD/MM/YYYY HH:mm') }} </small>
        </td>
        <td class="t_center"><span class="label" :class="{ 'label-default': item.status == 'done', 'label-warning': item.status == 'pending', 'bg_gray': item.status == 'canceled' }">{{ $t(item.status) }}</span> </td>
        <td class="t_center" v-if="deal.editable">
            <router-link :to="{ name: 'deals.show.tasks.edit', params: { id: item.deal_id, task: item.id } }" class="btn btn-warning btn-xs" v-pml-tooltip="$t('edit')" v-if="item.status !== 'done'">
                <i class="fa-fw fa fa-pencil"></i>
            </router-link>
            <span class="btn btn-danger btn-xs" v-pml-tooltip="$t('delete')" @click.prevent="askToDelete" v-pml-block="isDeleting" v-if="item.status !== 'done'"><i class="fa-fw fa fa-times"></i></span>
        </td>
    </tr>
</template>

<script>
    import Notify from 'utils/helpers/notify'
    import { trans } from 'utils/helpers/translation'
    import { destroy } from 'services/tasks'
    import { findMember, findAccessWay } from 'utils/helpers/find-store'
    import { askToDelete } from 'utils/helpers/sweet-alert'
    import { mapGetters } from 'vuex'
    import { isNil } from 'lodash'

    export default {
        name: 'TaskItem',
        props: [ 'item' ],
        data () {
            return {
                isDeleting: false
            }
        },
        computed: {
            ...mapGetters({
                'deal': 'getDealInfo'
            }),
            reasons () {
                return isNil(this.item.reasons) ? null : this.$options.filters.pmlNl2br(this.item.reasons)
            }
        },
        methods: {
            findMember: (id) => findMember(id),
            findAccessWay: (id) => findAccessWay(id),
            askToDelete () {
                askToDelete()
                    .then((response) => (response.value) ? this.destroy() : null)
            },
            destroy () {
                this.isDeleting = true

                destroy(this.item.deal_id, this.item.id)
                    .then(() => Notify.success(trans('_notifications.success')))
                    .catch(() => Notify.error(trans('_notifications.error')))
                    .then(() => { this.isDeleting = false })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/tasks/Item.vue